import SizeTips from "../../assets/size-tips.png";
import { Input, Select, Text } from "../base/Form";
import { parseFloatValue } from "utils/number";

export const CubeSizeInput = ({
  x,
  y,
  z,
  onChange,
  onBlur,
  unit = "mm",
  idPrefix,
  label = "Size",
}) => {
  return (
    <div className="flex items-center">
      <Input
        id={idPrefix ? `${idPrefix}-x` : undefined}
        aria-label={`${label} X`}
        className="w-20 text-center appearance-none"
        validated={!isNaN(x)}
        placeholder="X"
        value={x || 0}
        onChange={(e) => {
          onChange({ x: parseFloatValue(e.target.value), y, z });
        }}
        onBlur={onBlur}
      />
      <span className="px-4">&times;</span>
      <Input
        id={idPrefix ? `${idPrefix}-z` : undefined}
        aria-label={`${label} Z`}
        className="w-20 text-center appearance-none"
        validated={!isNaN(z)}
        placeholder="Z"
        value={z || 0}
        onChange={(e) => {
          onChange({ x, y, z: parseFloatValue(e.target.value) });
        }}
        onBlur={onBlur}
      />
      <span className="px-4">&times;</span>
      <Input
        id={idPrefix ? `${idPrefix}-y` : undefined}
        aria-label={`${label} Y`}
        className="w-20 text-center appearance-none"
        validated={!isNaN(y)}
        placeholder="Y"
        value={y || 0}
        onChange={(e) => {
          onChange({ x, y: parseFloatValue(e.target.value), z });
        }}
        onBlur={onBlur}
      />
      <span className="ml-2 font-bold">{unit}</span>
      <div className="ml-4">
        <img src={SizeTips} className="h-8" alt="cub size tips" />
      </div>
    </div>
  );
};

export const BallSizeInput = ({ diameter, onChange, unit = "mm" }) => {
  return (
    <div className="flex items-center">
      <Input
        className="w-20 text-center appearance-none"
        validated={!isNaN(diameter)}
        placeholder="Diameter"
        value={diameter}
        onChange={(e) => {
          onChange({ diameter: parseFloatValue(e.target.value) });
        }}
      />
      <span className="ml-2 font-bold">{unit}</span>
    </div>
  );
};

export const FlatSizeInput = ({ x, y, onChange, unit = "mm" }) => {
  return (
    <div className="flex items-center">
      <Input
        className="w-20 text-center appearance-none"
        validated={!isNaN(x)}
        placeholder="X"
        value={x || 0}
        onChange={(e) => {
          onChange({ x: parseFloatValue(e.target.value), y });
        }}
      />
      <span className="px-4">&times;</span>
      <Input
        className="w-20 text-center appearance-none"
        validated={!isNaN(y)}
        placeholder="Y"
        value={y || 0}
        onChange={(e) => {
          onChange({ x, y: parseFloatValue(e.target.value) });
        }}
      />
      <span className="ml-2 font-bold">{unit}</span>
    </div>
  );
};

export const CylindricalSizeInput = ({
  diameter,
  height,
  onChange,
  unit = "mm",
}) => {
  return (
    <div className="flex items-center">
      <Input
        className="w-24 text-center appearance-none"
        validated={!isNaN(diameter)}
        placeholder="Diameter"
        value={diameter}
        onChange={(e) => {
          onChange({ diameter: parseFloatValue(e.target.value), height });
        }}
      />
      <span className="px-4">&times;</span>
      <Input
        className="w-20 text-center appearance-none"
        validated={!isNaN(height)}
        placeholder="Height"
        value={height}
        onChange={(e) => {
          onChange({ diameter, height: parseFloatValue(e.target.value) });
        }}
      />
      <span className="ml-2 font-bold">{unit}</span>
    </div>
  );
};

export const MultiSizeInput = ({ text, onChange }) => {
  return (
    <div className="w-full mt-2">
      <Text
        placeholder="Each line should be a size, like: Component 1: 20mm x 30mm x 40mm."
        value={text}
        onChange={(e) => onChange({ text: e.target.value })}
      />
    </div>
  );
};

const ItemSizeInput = ({
  value = {
    shape: "cube",
    cubeX: 0,
    cubeY: 0,
    cubeZ: 0,
    ballRadius: 0,
    cylindricalRadius: 0,
    cylindricalHeight: 0,
    flatWidth: 0,
    flatHeight: 0,
    multiSizes: "",
  },
  onChange,
  unit = "mm",
}) => {
  return (
    <div
      className={
        value.shape === "multi" ? "flex-1" : "flex flex-1 items-center"
      }
    >
      <Select
        className="mr-4"
        value={value.shape || "0"}
        onChange={(e) => onChange({ ...value, shape: e.target.value })}
      >
        <option value="0" disabled>
          Select Shape
        </option>
        <option value="cube">Cube</option>
        <option value="ball">Ball</option>
        <option value="cylindrical">Cylindrical</option>
        <option value="flat">Flat</option>
        <option value="multi">Multi Sizes</option>
      </Select>

      {value.shape === "multi" ? (
        <div className="w-full mt-2">
          <Text
            placeholder="Each line should be a size, like: Component 1: 20mm x 30mm x 40mm."
            value={value.multiSizes}
            onChange={(e) => onChange({ ...value, multiSizes: e.target.value })}
          />
        </div>
      ) : (
        <div className="flex items-center">
          {value.shape === "ball" ? (
            <>
              <Input
                validated={!isNaN(value.ballDiameter)}
                className="w-20 text-center"
                placeholder="Radius"
                value={value.ballDiameter || 0}
                onChange={(e) => {
                  onChange({
                    ...value,
                    ballDiameter: parseFloatValue(e.target.value),
                  });
                }}
              />
              <span className="ml-2">{unit}</span>
            </>
          ) : value.shape === "cube" ? (
            <>
              <Input
                validated={!isNaN(value.cubeX)}
                className="w-20 text-center"
                placeholder="X"
                value={value.cubeX || 0}
                onChange={(e) => {
                  onChange({
                    ...value,
                    cubeX: parseFloatValue(e.target.value),
                  });
                }}
              />

              <span className="px-4">&times;</span>

              <Input
                validated={!isNaN(value.cubeZ)}
                className="w-20 text-center"
                placeholder="Z"
                value={value.cubeZ || 0}
                onChange={(e) => {
                  onChange({
                    ...value,
                    cubeZ: parseFloatValue(e.target.value),
                  });
                }}
              />

              <span className="px-4">&times;</span>

              <Input
                validated={!isNaN(value.cubeY)}
                className="w-20 text-center"
                placeholder="Y"
                value={value.cubeY}
                onChange={(e) => {
                  onChange({
                    ...value,
                    cubeY: parseFloatValue(e.target.value),
                  });
                }}
              />
              <span className="ml-2">{unit}</span>
              <div className="ml-4 flex items-center">
                <img src={SizeTips} className="h-8" alt="cub size tips" />
                <span className="ml-2 text-xs text-gray-500">
                  长(x) x 宽(z) x 高(y)
                </span>
              </div>
            </>
          ) : value.shape === "flat" ? (
            <>
              <Input
                validated={!isNaN(value.flatX)}
                className="w-20 text-center"
                placeholder="X"
                value={value.flatX || 0}
                onChange={(e) => {
                  onChange({
                    ...value,
                    flatX: parseFloatValue(e.target.value),
                  });
                }}
              />
              <span className="px-4">&times;</span>
              <Input
                validated={!isNaN(value.flatY)}
                className="w-20 text-center"
                placeholder="Y"
                value={value.flatY || 0}
                onChange={(e) => {
                  onChange({
                    ...value,
                    flatY: parseFloatValue(e.target.value),
                  });
                }}
              />
              <span className="ml-2">{unit}</span>
            </>
          ) : value.shape === "cylindrical" ? (
            <>
              <Input
                validated={!isNaN(value.cylindricalDiameter)}
                className="w-24 text-center"
                placeholder="Diameter"
                value={value.cylindricalDiameter}
                onChange={(e) => {
                  onChange({
                    ...value,
                    cylindricalDiameter: parseFloatValue(e.target.value),
                  });
                }}
              />
              <span className="px-4">&times;</span>
              <Input
                validated={!isNaN(value.cylindricalHeight)}
                className="w-20 text-center"
                placeholder="Height"
                value={value.cylindricalHeight}
                onChange={(e) => {
                  onChange({
                    ...value,
                    cylindricalHeight: parseFloatValue(e.target.value),
                  });
                }}
              />
              <span className="ml-2">{unit}</span>
            </>
          ) : (
            <div>Unknown shape</div>
          )}
        </div>
      )}
    </div>
  );
};

export default ItemSizeInput;
